import { OPEN_API_TEST, OPEN_API_PRO, BASE_URL } from "@/constants/index";

export function queryItemApi() {
  const apiUrlTest = "/gateway/edi/product/query"; //测试环境接口地址
  // const isCn = (localStorage.getItem("lang") || "CN") === "CN";
  return {
    //当前请求URL
    apiBaseUrl: BASE_URL + `${apiUrlTest}`,

    onlineData: {
      // 接口描述
      apiDesc: "apiDocDesc.itemapiDesc",
      //接口地址
      testApi: `${OPEN_API_TEST}${apiUrlTest}`,
      proApi: `${OPEN_API_PRO}${apiUrlTest}`,
      infos: [
        [
          {
            key: "apiDocDesc.testUrl",
            value:
              "https://demo-sop.jtfulfillment.cn/gateway/edi/product/query"
          },
          {
            key: "apiDocDesc.proUrl",
            value: "https://sop.jtfulfillment.cn/gateway/edi/product/query"
          },
          { key: "customerid:", value: "CS001" },
         
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "YL001" },
          { key: "eccompanyid:", value: "STANDARD" },
          {
            key: "KEY:",
            value: "MGY3MTU3M2M3NjYxN2RhNjc3NzM4MzM2Y2Q5ZjQ0ZWU="
          }
        ],
        [
          {
            key: "apiDocDesc.testUrlCn",
            value:
              "https://demo-openapi.jtfulfillment.cn/gateway/edi/product/query"
          },
          {
            key: "apiDocDesc.proUrlCn",
            value: "https://openapi.jtfulfillment.cn/gateway/edi/product/query"
          },
          { key: "customerid:", value: "UPFOS-TEST" },
          
          { key: "warehouseCode:", value: "SH.001" },
          { key: "itemCode:", value: "STZX0000001" },  
          { key: "eccompanyid:", value: "UPFOS-TEST_PPL" },
          {
            key: "KEY:",
            value: "ZDZmNTM1NWE2ZDQ5NjU4Y2Q4YzY5YWIwZGRjZTEyMzE="
          }
        ]
      ],
      //参数描述  START
      postDataList: [
        //   请求头参数
        {
          title: "onlineDoc.请求参数",
          value: [
            {
              name: "customerid",
              type: "VARCHAR",
              require: "Y",
              normal: "CS001",
              describe: "apiDocDesc.customeridDesc45"
            },
            {
              name: "itemCode",
              type: "VARCHAR",
              require: "N",
              normal: "YL001",
              describe: "apiDocDesc.itemCodeDesc46"
            },
            {
              name: "warehouseCode",
              type: "VARCHAR",
              require: "Y",
              normal: "SH.001",
              describe: "apiDocDesc.warehouseCodeDesc47"
            },
            {
              name: "startPage",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.startPageDesc48"
            },
            {
              name: "pageSize",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.pageSizeDesc49"
            },
            {
              name: "startdate",
              type: "DATE",
              require: "N",
              normal: "",
              describe: "apiDocDesc.startdateDesc50"
            },
            {
              name: "enddate",
              type: "DATE",
              require: "N",
              normal: "",
              describe: "apiDocDesc.enddateDesc51"
            }
          ]
        }
      ],
      //参数描述  END
      //报文描述 start
      responseDataList: [
        {
          title: "onlineDoc.响应参数",
          value: [
            {
              name: "logisticproviderid",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.logisticprovideridDesc52"
            },
            {
              name: "total",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.totalDesc53"
            },
            {
              name: "pages",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.pagesDesc54"
            },
            {
              name: "page",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.pageDesc55"
            },
            {
              name: "pageSize",
              type: "INT",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.pageSizeDesc56"
            },
            {
              name: "success",
              type: "BOOLEAN",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.successDesc57"
            },
            {
              name: "reason",
              type: "VARCHAR",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.reasonDesc58"
            },
            {
              name: "baseList",
              type: "LIST",
              require: "Y",
              normal: "",
              describe: "apiDocDesc.baseListDesc59",
              children: [
                {
                  name: "companyCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.companyCodeDesc60"
                },
                {
                  name: "warehouseCode",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.warehouseCodeDesc61"
                },
                {
                  name: "sku",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.skuDesc62"
                },
                {
                  name: "shortskuCode",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.shortskuCodeDesc63"
                },
                // {
                //   name: "skuStatus",
                //   type: "VARCHAR",
                //   require: "N",
                //   normal: "",
                //   describe: "apiDocDesc.skuStatusDesc64"
                // },
                {
                  name: "skuType",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.skuTypeDesc65"
                },
                {
                  name: "chName",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.chNameDesc66"
                },
                {
                  name: "enName",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.enNameDesc67"
                },
                {
                  name: "color",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.colorDesc68"
                },
                {
                  name: "productSize",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.productSizeDesc69"
                },
                {
                  name: "unit",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.unitDesc70"
                },
                {
                  name: "isElectricity",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.isElectricityDesc71"
                },
                {
                  name: "electricityCapacity",
                  type: "DECEMAL",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.electricityCapacityDesc72"
                },
                {
                  name: "goodsLong",
                  type: "DECEMAL",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.goodsLongDesc73"
                },
                {
                  name: "goodsWidth",
                  type: "DECEMAL",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.goodsWidthDesc74"
                },
                {
                  name: "goodsHeight",
                  type: "DECEMAL",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.goodsHeightDesc75"
                },
                {
                  name: "weight",
                  type: "DECEMAL",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.weightDesc76"
                },
                {
                  name: "isBaocai",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.isBaocaiDesc77"
                },
                {
                  name: "isImei",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.isImeiDesc78"
                },
                {
                  name: "outstorageControl",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.outstorageControlDesc79"
                },
                {
                  name: "putawayControl",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.putawayControlDesc80"
                },
                {
                  name: "isDualImei",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.isDualImeiDesc81"
                },
                {
                  name: "isBatch",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.isBatchDesc82"
                },
                {
                  name: "lifeControl",
                  type: "INT",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.lifeControlDesc83"
                },
                {
                  name: "validityPeriod",
                  type: "INT",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.validityPeriodDesc84"
                },
                {
                  name: "boxQty",
                  type: "INT",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.boxQtyDesc85"
                },
                {
                  name: "packageUnit",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.packageUnitDesc86"
                },
                {
                  name: "exportCurrency",
                  type: "VARCHAR",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.exportCurrencyDesc87"
                },
                {
                  name: "exportUnitPrice",
                  type: "DECEMAL",
                  require: "Y",
                  normal: "",
                  describe: "apiDocDesc.exportUnitPriceDesc88"
                },
                {
                  name: "remark",
                  type: "VARCHAR",
                  require: "N",
                  normal: "",
                  describe: "apiDocDesc.remarkDesc89"
                }
              ]
            }
          ]
        }
      ],
      //请求示例
      requestCode: {
        command: 2,
        ordertype: "XSCK",
        status: "1",
        customerid: "DEV-TEST",
        serialnumber: "20240627202934571",
        warehouseCode: "SH.001"
      },
      //返回示例
      responseCode: {
        logisticproviderid: "YL",
        traceId: "3daa4f2d17195395941078999e",
        responseitems: [
          {
            success: "true",
            reason: "",
            errorMsg: null,
            orderList: [
              {
                eccompanyid: "UPFOS",
                mailno: "20240627202934571",
                customerid: "DEV-TEST",
                txlogisticid: "20240627202934571",
                orderstatus: "待复核",
                warehouseCode: "SH.001",
                ordertype: "XSCK",
                paytype: null,
                routeid: "123",
                outboundtype: "C1",
                transport: "1018003",
                goodstype: null,
                itemsvalue: "100.7800",
                weight: null,
                totalquantity: "2",
                remark: "TESTING, JANGAN DILANJUT!!!",
                pricecurrency: "PHP",
                sender: {
                  company: null,
                  name: null,
                  postcode: null,
                  mailbox: null,
                  phone: null,
                  mobile: null,
                  countrycode: null,
                  prov: null,
                  city: null,
                  area: null,
                  address: null,
                  address1: null,
                  address2: null,
                  country: null
                },
                receiver: {
                  company: null,
                  name: "mick",
                  postcode: "155555",
                  phone: "**********7866",
                  mobile: "**********4590",
                  countrycode: null,
                  prov: "OCCIDENTAL-MINDORO",
                  city: "OCCIDENTAL-MINDORO-MAGSAYSAY",
                  area: "CALAWAG",
                  address: "Address101",
                  address1: null,
                  address2: "",
                  country: null,
                  idNumber: null,
                  idNumberUrl: null,
                  supplierCode: null,
                  shipTo: null
                },
                items: [
                  {
                    itemCode: "123456",
                    itemName: "123456",
                    englishName: null,
                    number: "1",
                    itemvalue: null,
                    pricecurrency: null,
                    itemurl: null,
                    hscode: null,
                    itemType: null,
                    ylsku: null,
                    desc: null,
                    sptype: null,
                    remark: null,
                    requestQty: null,
                    quantity: 1,
                    lockQuantity: 0,
                    saleQuantity: 0,
                    stockRemark: null,
                    unitLength: null,
                    unitWidth: null,
                    unitHeight: null,
                    isElectricity: null,
                    lineNo: null,
                    isGift: null,
                    inventoryType: null,
                    productDate: null,
                    produceCode: null,
                    batchCode: null,
                    reserved1: null,
                    snList: {
                      sn: ["iECUks0M8v"]
                    }
                  }
                ],
                cusname: null,
                transferFlag: null,
                transferType: null,
                covertemplate: null,
                saddressEn: null,
                carrier: "JT",
                label: "https://www.qq.com",
                pickType: "",
                stockTime: null,
                businessMode: "B2C",
                goodsValue: null,
                customerPo: null,
                verifyStatus: null,
                verifyResult: null,
                source: "*",
                createOrderTime: "2023-05-16 15:05:12",
                createOrderTimeDate: null,
                storeCode: "DIANXIAOMI-店铺编码",
                storeName: null,
                thirdCustomerCode: null,
                pickUp: null,
                offerFee: null,
                insuranceValue: null,
                insuranceCurrency: null,
                useInsurance: null,
                code: "20240627202934571",
                shippingMethod: 9999,
                routeCode: null,
                packageCenterCode: null,
                isCod: null,
                expressBillFlag: null,
                platformNumber: "20240627202934571",
                payTime: null,
                created: "2024-06-27T20:29:35",
                storerKey: null,
                sourceSystem: null,
                outBizNo: null,
                transportMode: null,
                reserved1: null,
                businessType: null
              }
            ],
            entryOrderCode: null,
            entryOrderId: null
          }
        ]
      }
    }
  };
}
